module.exports = __webpack_public_path__ + "static/img/RAPW-K_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAPW-K_1.png
// module id = oHnV
// module chunks = 0